// JOBE-0106: SettingsTab — read-only summary card per the spec.
// No write affordances in v1 except the "Reassign owner →" link
// rendered on the People lane. The full edit surface is deferred
// per ADR-0023 §5.

import React from 'react';
import { Link } from 'react-router-dom';

function urnTail(urn) {
  if (!urn || typeof urn !== 'string') return '';
  return urn.split(':').pop() || urn;
}

export function SettingsTab({ project }) {
  if (!project) {
    return (
      <section className="project-settings-tab muted" data-testid="project-settings-tab">
        No project data.
      </section>
    );
  }
  const department =
    (project?.relations?.inDepartment && project.relations.inDepartment[0]) || null;
  const creator =
    (project?.relations?.createdBy && project.relations.createdBy[0])
    || project?.createdBy
    || null;

  return (
    <section className="project-settings-tab card" data-testid="project-settings-tab">
      <h3 className="lane-title">Settings</h3>
      <dl className="project-settings-list">
        <dt>URN</dt>
        <dd className="mono">{project.urn}</dd>
        <dt>Status</dt>
        <dd>{project.status || project?.fields?.status || '—'}</dd>
        <dt>Target date</dt>
        <dd>{project.targetDate || project?.fields?.targetDate || '—'}</dd>
        <dt>Department</dt>
        <dd>{department ? <span className="mono">{urnTail(department)}</span> : '—'}</dd>
        <dt>Creator</dt>
        <dd>{creator ? <span className="mono">{urnTail(creator)}</span> : '—'}</dd>
        <dt>Graph</dt>
        <dd className="mono">public</dd>
        <dt>On delete</dt>
        <dd className="mono">archive cascades · hard delete blocked</dd>
      </dl>
      <Link
        to={`/entities/${encodeURIComponent(project.urn)}`}
        className="project-settings-edit-link"
        data-testid="settings-edit-link"
      >
        Edit in entity inspector →
      </Link>
    </section>
  );
}
